import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { TransactionFile } from "../Entities/TransactionFile/TransactionFile";
import { TransactionFileInterface } from "../Entities/TransactionFile/TransactionFileInterface";
import StatusContainer from "../Entities/TransactionFile/Status/StatusContainer";
import PaymentFactory from "../../Entity/Factories/PaymentFactory";

class TransactionFileFactory extends Factory implements FactoryInterface {

  public create(data: any): TransactionFileInterface {
    return new TransactionFile({
      id: data.id,
      name: data.name,
      path: data.path,
      createdAt: new Date(data.createdAt),
      createdBy: data.createdBy,
      statusId: data.statusId,
      status: StatusContainer.pickFromId(data.statusId),
      reason: data.reason,
      removed: data.removed,
      processedPaymentIds: data.processedPaymentIds,
      payments: (data.payments || []).map(payment => {
        return PaymentFactory.create(payment);
      }),
      description: data.description,
      oldestTransactionDate: data.oldestTransactionDate === null ? null : new Date(data.oldestTransactionDate),
      newestTransactionDate: data.newestTransactionDate === null ? null : new Date(data.newestTransactionDate),
    });
  }

  public reinitialize(data: any): TransactionFileInterface {
    return new TransactionFile({
      ...data
    });
  }
}

export default new TransactionFileFactory();
